import React from 'react';
import * as styles from './Location.module.scss';
import useLocation from '../../hooks/useLocation';
import { LocationIcon } from '../Icons/V2';

const Location = () => {
  const { country, city, isLoading } = useLocation();

  if (!isLoading && !country && !city) {
    return null;
  }

  const countryName =
    country === 'United States of America (the)' ? 'USA' : country;

  return (
    <div className={styles.v2Location}>
      <LocationIcon />
      <p>{isLoading ? 'loading...' : `${city}, ${countryName}`}</p>
    </div>
  );
};

export default Location;
